module.exports = __webpack_public_path__ + "static/media/SyndicationPortal.73cb8d2c.svg";